import { render, staticRenderFns } from "./DirectRoomLogin.vue?vue&type=template&id=36f783cb&scoped=true&"
import script from "./DirectRoomLogin.vue?vue&type=script&lang=js&"
export * from "./DirectRoomLogin.vue?vue&type=script&lang=js&"
import style0 from "./DirectRoomLogin.vue?vue&type=style&index=0&id=36f783cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f783cb",
  null
  
)

export default component.exports